(function () {
  function init() {
    var wrapper = document.querySelector('[data-grad-reg]');
    if (!wrapper) return;
    var formId = wrapper.getAttribute('data-form-id');
    var form = formId ? document.getElementById(formId) : wrapper.closest('form');
    if (!form) return;
    var errorBox = wrapper.querySelector('[data-grad-reg-error]');
    function fields() {
      return Array.prototype.slice.call(
        wrapper.querySelectorAll('[name^="properties["]')
      );
    }
    // Phone auto-format xxx-xxx-xxxx
    wrapper.querySelectorAll('.grad-reg__phone').forEach(function (input) {
      input.addEventListener('input', function () {
        var d = input.value.replace(/\D/g, '').slice(0, 10);
        var out = d;
        if (d.length > 6) out = d.slice(0,3) + '-' + d.slice(3,6) + '-' + d.slice(6);
        else if (d.length > 3) out = d.slice(0,3) + '-' + d.slice(3);
        input.value = out;
      });
    });
    function isEmail(v){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }
    function isPhone(v){ return /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/.test(v); }
    function problems() {
      var errs = [];
      fields().forEach(function (input) {
        var val = (input.value || '').trim();
        var labelEl = wrapper.querySelector('label[for="' + input.id + '"]');
        var label = labelEl ? labelEl.textContent.replace('*','').trim() : input.name;
        if (input.required && val === '') { errs.push(label + ' is required.'); return; }
        if (val !== '') {
          if (input.type === 'email' && !isEmail(val)) errs.push(label + ' must be a valid email address.');
          else if (input.classList.contains('grad-reg__phone') && !isPhone(val)) errs.push(label + ' must be in the format xxx-xxx-xxxx.');
        }
      });
      return errs;
    }
    function showErrs(errs) {
      if (!errorBox) return;
      if (errs.length > 0) { errorBox.hidden = false; errorBox.textContent = errs[0]; }
      else { errorBox.hidden = true; errorBox.textContent = ''; }
    }
    function isAddButton(el) {
      return el && el.closest && el.closest('[data-action="add-to-cart"]');
    }

    // Build/refresh a hidden dedup key from graduate first + last + email,
    // normalized (trim + lowercase). Two registrations for the same graduate
    // produce an identical key, so Shopify merges them into one line at qty 2,
    // which the quantity validation function then blocks. The leading
    // underscore in the property name keeps it hidden from cart/checkout.
    function setDedupKey() {
      function normVal(id) {
        var el = document.getElementById(id);
        return el ? (el.value || '').trim().toLowerCase() : '';
      }
      var key = normVal('grad-grad-first') + '|' +
                normVal('grad-grad-last') + '|' +
                normVal('grad-grad-email');
      var dedupInput = document.getElementById('grad-dedup-key');
      if (!dedupInput) {
        dedupInput = document.createElement('input');
        dedupInput.type = 'hidden';
        dedupInput.id = 'grad-dedup-key';
        dedupInput.name = 'properties[_dedup_key]';
        dedupInput.setAttribute('form', formId);
        wrapper.appendChild(dedupInput);
      }
      dedupInput.value = key;
    }

    // EARLIEST POSSIBLE INTERCEPT:
    // Capture-phase click listener on the document. This runs before the theme
    // OR the BOGOS app can react. If the form is invalid, we kill the event here.
    document.addEventListener('click', function (e) {
      if (!isAddButton(e.target)) return;      // only the Add to Cart button
      var errs = problems();
      if (errs.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        showErrs(errs);
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        showErrs([]);

        // Normalize before add so near-duplicate entries collide properly.
        // Trim all fields; lowercase email fields. Display data the user sees
        // is still what they typed; this only tidies whitespace/email case.
        function titleCase(str) {
          return str.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        }
        fields().forEach(function (input) {
          var v = (input.value || '').trim();
          if (input.type === 'email') {
            v = v.toLowerCase();
          } else if (input.classList.contains('grad-reg__phone')) {
            // leave phone formatting as-is
          } else {
            // name/text fields -> consistent title case
            v = titleCase(v);
          }
          input.value = v;
        });

        // Set the hidden dedup key from the (now normalized) graduate fields.
        setDedupKey();

        // Valid add: let the theme/app capture the values, then clear ONLY the
        // three graduate fields (keep parent info for twins/siblings workflow),
        // plus the hidden dedup key so it doesn't linger for the next add.
        setTimeout(function () {
          ['grad-grad-first', 'grad-grad-last', 'grad-grad-email', 'grad-dedup-key'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el) el.value = '';
          });
        }, 800);
      }
    }, true); // <-- true = capture phase (runs first)
    // Also guard the form's submit as a backstop, capture phase.
    form.addEventListener('submit', function (e) {
      var errs = problems();
      if (errs.length > 0) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        showErrs(errs);
      }
    }, true);
    // Keep quantity locked to 1
    form.querySelectorAll('[name="quantity"]').forEach(function (q) { q.value = '1'; });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();